export default __webpack_public_path__ + "static/media/RUSU_TATIANA.886a7d86.jpg";